import { Pipe, PipeTransform } from '@angular/core';
import { Evento } from '../../pages/eventos/eventos.modelview';

/**
 * Generated class for the FiltroEventoPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'eventoFiltro',
})
export class EventoFiltroPipe implements PipeTransform {
  
  transform(value: Array<Evento>, ...args) {
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/eventos-filtro/eventos-filtro.ts